import { motion } from "framer-motion";

const STEPS = [
  {
    num: "1",
    fill: "bg-amber",
    title: "Free Quote",
    body: "Answer a few quick questions and get a no-obligation quote.",
  },
  {
    num: "2",
    fill: "bg-gdark",
    title: "Rebates & Paperwork",
    body: "We handle the rebate applications and paperwork for you.",
  },
  {
    num: "3",
    fill: "bg-amber",
    title: "Install in Under a Week",
    body: "Licensed installers fit your new system, tested same day.",
  },
];

const HowItWorks = () => {
  return (
    <section
      data-testid="how-it-works-section"
      className="bg-white py-20 md:py-28"
    >
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="text-center mb-14"
        >
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-gdark">
            How it works
          </p>
          <h2 className="mt-4 font-serif font-bold text-navy tracking-tight text-4xl md:text-5xl leading-tight">
            From quote to hot water in under a week.
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6 md:gap-8">
          {STEPS.map((step, i) => (
            <motion.div
              key={step.num}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              data-testid={`how-step-${step.num}`}
              className="bg-cream rounded-[20px] p-8"
            >
              <span
                className={`inline-flex items-center justify-center w-11 h-11 rounded-full ${step.fill} text-white font-bold text-lg`}
              >
                {step.num}
              </span>
              <h3 className="mt-5 text-xl font-semibold text-navy">
                {step.title}
              </h3>
              <p className="mt-2 text-base text-navy-muted leading-relaxed">
                {step.body}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
